/**
 * Copyright (c) ProductiveHub, Inc. All Rights Reserved.
 *
 *
 * @summary
 * @author Andrew McCrink <andrew@emagid.com>
 *
 * Created: 11/17/2021
 */
import React, { useState, useEffect } from "react";
import { pagesApi, getDocument } from "../proxy";
import { db } from "../firebase";
import { onSnapshot, doc } from "firebase/firestore";

export interface PagesContext {
  pages: any;
  loadingPages: boolean;
  findPage: (slug: string) => any;
  homepage: any;
}

export interface PagesProviderProps {
  children: React.ReactNode;
}

export const PagesContext = React.createContext<PagesContext | undefined>(
  undefined
);

export const PagesProvider: React.FC<PagesProviderProps> = (
  props: PagesProviderProps
) => {
  const [pages, setPages] = useState<any | null>(null);
  const [loadingPages, setLoadingPages] = useState<any | null>(true);
  const [homepage, setHomepage] = useState<any>(null);

  useEffect(() => {
    const unsub = getPages();
    return () => unsub();
  }, []);

  useEffect(() => {
    const unsub = getHomepage();
    return () => unsub();
  }, []);

  const getPages = () => {
    return onSnapshot(doc(db, "formattedPages", "master"), (doc: any) => {
      setPages(doc.exists() ? doc.data().pages : null);
    });
  };

  const getHomepage = () => {
    return onSnapshot(doc(db, "homepage", "content"), (doc: any) => {
      setHomepage(doc.exists() ? doc.data().data : null);
    });
  };

  const findPage = (slug: string) => {
    return pages?.find((page: any) => {
      return page.slug === slug;
    });
  };

  return (
    <PagesContext.Provider
      value={{
        pages,
        loadingPages,
        findPage,
        homepage,
      }}
    >
      {props.children}
    </PagesContext.Provider>
  );
};

export const usePages = () => React.useContext(PagesContext);
